export default {"src":"/_next/static/media/MD.c0de1bfa.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};